import {GQL_SponsorFragment} from '../generated/graphql'
import {Sponsor} from '../common/types/sponsor'

export const transformSponsor = (sponsor: GQL_SponsorFragment): Sponsor => ({
  id: sponsor.id,
  imageName: sponsor.imageName,
  name: sponsor.name,
  url: sponsor.url ?? undefined,
})
